import styled from 'styled-components';



const HeaderWrapper = styled.header`
  min-height: 10vh;
  margin-top:10vh;
  display: flex;
  flex-direction: column;
  font-size: 30px;

  h1 {
    margin: 0;
    padding-bottom: 30px;
    font-family: "Quicksand", serif;
    color: rgb(0,0,0,.8);
  }

  nav {
    display: flex;
    gap: 25px;
    justify-content:center;
  }

  a {
    text-decoration: none;
    color: #000;
    font-size: 16px;
    border: 1px solid black;
    padding: 5px 10px;
    font-family:"Quicksand";
     transition: background-color 0.3s, box-shadow 0.3s, border-color 0.3s, border-width 0.3s;

  }

  a:hover {
     color:black;
         border-color: transparent; /* Change border color to transparent */
  }

  a:nth-child(1):hover {
    box-shadow: 0px 0px 30px #D45F5F;

  }

  a:nth-child(2):hover {

    box-shadow: 0px 0px 20px darkorange;

  }

  a:nth-child(3):hover {

    box-shadow: 0px 0px 20px darkgreen;

  }

  a:nth-child(4):hover {
    box-shadow: 0px 0px 20px darkblue;

  }

   @media (max-width: 768px) {
    font-size: 20px;

    a {
      font-size: 18px;
    }

    nav {
      gap: 20px;
    }
  }

  @media (max-width: 480px) {
    font-size: 20px;

    a {
      font-size: 16px;
    }

    nav {
      gap: 15px;
      align-items: flex-start;
    }
  }
`;

const NoteWrapper = styled.div`
  display:flex;
  justify-content: center;
  img {
    height: 100px;
    width: 100px;
    -webkit-animation: mover 2s infinite alternate;
    animation: mover 2s infinite alternate;
  }
  img:nth-child(odd) {
    -webkit-animation: mover2 3s infinite alternate;
    animation: mover2 3s infinite alternate;
  }
  img:nth-child(even) {
    -webkit-animation: mover 2s infinite alternate;
    animation: mover 2s infinite alternate;
  }

  
@-webkit-keyframes mover {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(-5px);
    }
}

@keyframes mover {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(-5px);
    }
}

@-webkit-keyframes mover2 {
    0% {
        transform: translateY(5px);
    }

    100% {
        transform: translateY(-5px);
    }
}

@keyframes mover2 {
    0% {
        transform: translateY(5px);
    }

    100% {
        transform: translateY(-5px);
    }
}
  

`
function Header() {
  return (
    <HeaderWrapper>
      <NoteWrapper>
        <img src="/images/note.png" alt="note"></img>
        <img src="/images/note2.png" alt="note2"></img>
        <img src="/images/note.png" alt="note"></img>
        <img src="/images/note2.png" alt="note2"></img>
      </NoteWrapper>

      <h1>Hello, I'm Angela</h1>

      <nav>
        <a href="https://github.com/kyunghei">GitHub</a>
        <a href="https://www.linkedin.com/in/kyung-angela/">LinkedIn</a>
        <a href="mailto:angelakh.seo@gmail.com">Contact</a>
        <a href="https://drive.google.com/file/d/15YlD7YxYsfxv2NaDS_tFkgpsZyy70Fct/view?usp=sharing">Resume</a>
      </nav>
    </HeaderWrapper>
  )

}

export default Header;